import { Spacing16, Spacing4, Spacing6 } from 'autogen/design-tokens/tokens';
import { css } from 'styled-components';

const regimeTheme = {
    Wrapper: css`
        height: 100%;
    `,
    StyledCard: css`
        border: 0 !important;
    `,
    ProductCard: css`
        border: 0;
    `,
    ProductCardMid: css`
        padding: ${Spacing6} ${Spacing16} 0;
    `,
    ProductCardBottom: css`
        padding: 0 ${Spacing16} ${Spacing16};
    `,
    ProductDescriptionContainer: css`
        gap: ${Spacing4};
        grid-template-areas:
            "text checkbox"
            "price button";
    `,
    SplashOverlay: css`
        display: none;
    `,
    TagSplash: css`
        display: none;
    `,
    RatingContainer: css`
        display: none;
    `,
    RatingPlaceholder: css`
        display: none;
    `,
    ButtonWithAnimatedStatuses: css`
        display: none;
    `,
    ButtonStyling: css`
        display: none;
    `
};
export default regimeTheme;
